import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Edit,
  useForm,
} from "@pankod/refine-antd";
import { IContents} from "interfaces";
import {ContentsForm} from "components/forms";

export const ContentsEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IContents>();
  return (
    <Edit saveButtonProps={saveButtonProps}>
      <ContentsForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Edit>
  );
};
